import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function Header() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsMenuOpen(false); // Close menu after logout
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleChatClick = (e) => {
    e.preventDefault();
    
    // If we're already on the leaderboard page, just scroll
    if (window.location.pathname === '/leaderboard') {
      const commentsSection = document.getElementById('comments-section');
      if (commentsSection) {
        commentsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to leaderboard with hash, but also force the hash in the URL
      window.location.href = '/leaderboard#comments';
    }
    
    setIsMenuOpen(false); // Close menu after navigation
  };

  return (
    <header className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold">F1 Predictor</Link>
        
        {/* Hamburger button - only visible on mobile */}
        <button 
          onClick={toggleMenu}
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1"
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
        
        {/* Desktop navigation - hidden on mobile */}
        <nav className="hidden md:block">
          <ul className="flex space-x-4 list-none items-center">
            <li><Link to="/" className="text-white hover:text-gray-300">Home</Link></li>
            <li><Link to="/predictions" className="text-white hover:text-gray-300">Predictions</Link></li>
            <li><Link to="/leaderboard" className="text-white hover:text-gray-300">Leaderboard</Link></li>
            <li><Link to="/results" className="text-white hover:text-gray-300">Results</Link></li>
            <li><Link to="/roadmap" className="text-white hover:text-gray-300">Roadmap</Link></li>
            <li>
              <a 
                href="/leaderboard#comments"
                onClick={handleChatClick}
                className="text-white hover:text-gray-300 cursor-pointer"
              >
                Chat
              </a>
            </li>
            
            {user ? (
              <>
                <li className="text-white bg-gray-700 px-3 py-1 rounded">Welcome, {user.username}</li>
                <li>
                  <button 
                    onClick={handleLogout}
                    className="text-white hover:text-gray-300 bg-red-600 hover:bg-red-700 px-3 py-1 rounded transition-colors"
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li><Link to="/login" className="text-white hover:text-gray-300">Login</Link></li>
                <li><Link to="/register" className="text-white hover:text-gray-300">Register</Link></li>
              </>
            )}
          </ul>
        </nav>
      </div>
      
      {/* Mobile navigation menu - slides down when hamburger is clicked */}
      <div className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="bg-gray-800 mt-4 border-t border-gray-700 pt-4 pb-6">
          <ul className="flex flex-col space-y-3 list-none">
            <li><Link to="/" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Home</Link></li>
            <li><Link to="/predictions" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Predictions</Link></li>
            <li><Link to="/leaderboard" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Leaderboard</Link></li>
            <li><Link to="/results" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Results</Link></li>
            <li><Link to="/roadmap" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Roadmap</Link></li>
            <li>
              <a 
                href="/leaderboard#comments"
                onClick={handleChatClick}
                className="block text-white hover:text-gray-300 py-2 cursor-pointer"
              >
                Chat
              </a>
            </li>
            
            {user ? (
              <>
                <li className="text-white py-2 border-t border-gray-700 pt-3 mt-2">Welcome, {user.username}</li>
                <li className="pb-2">
                  <button 
                    onClick={handleLogout}
                    className="w-full text-left text-white bg-red-600 hover:bg-red-700 py-3 px-4 rounded transition-colors border-0 outline-none font-medium"
                    style={{ backgroundColor: '#dc2626', display: 'block' }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="border-t border-gray-700 pt-3 mt-2">
                  <Link to="/login" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Login</Link>
                </li>
                <li>
                  <Link to="/register" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Register</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;